/**
 * 會員中心側邊欄選單 action 列舉。
 * label 是顯示文字，可隨時翻譯/改名而不影響邏輯判斷。
 * 每個分頁對應一個 action，AccountPage 依 action 切換畫面。
 */
export const MENU_ACTIONS = {
  DASHBOARD: 'dashboard',
  ORDERS:    'orders',
  BOOST:     'boost',
  POINTS:    'points',
  ADDRESSES: 'addresses',
  PROFILE:   'profile',
  NOTIFS:    'notifs',
  LOGOUT:    'logout',
};

/**
 * 會員中心側邊欄選單。
 * 後端如果提供未讀數量，可改成由 API 派生 badge。
 * 帶 `action` 的項目切換對應分頁；LOGOUT 有特殊行為。
 *
 */
export const MENU_ITEMS = [
  { label: '總覽 Dashboard', action: MENU_ACTIONS.DASHBOARD },
  { label: '我的訂單',       action: MENU_ACTIONS.ORDERS },
  { label: '代打資料',       action: MENU_ACTIONS.BOOST },
  { label: '點數紀錄',       action: MENU_ACTIONS.POINTS },
  { divider: true },
  { label: '收貨地址',       action: MENU_ACTIONS.ADDRESSES },
  { label: '個人資料',       action: MENU_ACTIONS.PROFILE },
  // 通知設定暫時隱藏——功能未做（開關/儲存都還沒接後端）。頁面/元件保留，之後要做再把這行加回。
  // { label: '通知設定',       action: MENU_ACTIONS.NOTIFS },
  { divider: true },
  { label: '登出', action: MENU_ACTIONS.LOGOUT, danger: true },
];

/**
 * 個人資料分頁的補充欄位 mock（真實後端 user 目前只回 id/name/email/role）。
 */
export const ACCOUNT_PROFILE = {
  nickname: '柏宇YU',
  phone:    '0912-345-678',
  gender:   'm',
  birthday: '1996-04-18',
  machine:  'D3',
};

/**
 * 點數紀錄 mock。後端 API: GET /api/me/points
 */
export const POINTS = [
  { date: '2026/05/28', label: '訂單 MD-20251108 消費回饋', delta: 16,  type: 'earn' },
  { date: '2026/05/20', label: '訂單 MD-20251023 消費回饋', delta: 15,  type: 'earn' },
  { date: '2026/05/15', label: '商品評價獎勵',              delta: 20,  type: 'earn' },
  { date: '2026/05/11', label: '兌換 NT$50 折價券',         delta: -50, type: 'spend' },
  { date: '2026/04/30', label: '訂單 MD-20251005 消費回饋', delta: 13,  type: 'earn' },
  { date: '2026/04/18', label: '生日禮金點數',              delta: 100, type: 'earn' },
];

/**
 * 收貨地址 mock。後端 API: GET/POST/PUT/DELETE /api/me/addresses
 */
export const ADDRESSES = [
  { id: 'a1', name: '陳柏宇', phone: '0912-345-678', zip: '106', addr: '台北市大安區忠孝東路四段 100 號 8 樓', isDefault: true, label: '住家' },
  { id: 'a2', name: '陳柏宇', phone: '0912-345-678', zip: '110', addr: '台北市信義區松壽路 12 號（MICHIDART 信義店 自取）', isDefault: false, label: '門市自取' },
];

/**
 * 通知設定 mock。後端 API: GET/PUT /api/me/notification-settings
 */
export const NOTIFS = [
  { id: 'order', label: '訂單與物流狀態', desc: '出貨、配送、完成等通知', on: true },
  { id: 'boost', label: '代打進度更新',   desc: '登記受理、處理中、完成發碼', on: true },
  { id: 'promo', label: '優惠與活動',     desc: '折扣碼、會員日、限時特賣', on: true },
  { id: 'point', label: '點數與等級',     desc: '點數到期提醒、升等通知', on: false },
  { id: 'news',  label: '電子報',         desc: '每月新品與賽事情報', on: false },
];

/**
 * 登記付款方式選項。前端只記錄客人偏好；老闆確認後才通知實際應付金額，前端不收款。
 */
export const PAY_METHODS = [
  { id: 'transfer', label: '銀行轉帳', desc: '送出後提供匯款帳號' },
  { id: 'linepay',  label: 'LINE Pay', desc: '確認後傳付款連結' },
  { id: 'paypal',   label: 'PayPal',   desc: '確認後傳付款連結' },
];

/**
 * 登記狀態對照。submitted → processing → done → coded（step 用於進度條）。
 */
export const REG_STATUS = {
  submitted:  { label: '已送出', step: 1 },
  processing: { label: '處理中', step: 2 },
  done:       { label: '已完成', step: 3 },
};

/**
 * 我的登記紀錄 mock。後端 API: GET /api/me/registrations（回傳含 status、code?）
 * 一筆登記可含多張卡（一人幫多位朋友批次登記）。沒有密碼欄位。
 */
export const REGISTRATIONS = [
  {
    id: 'BR-3082', createdAt: '2026/05/28 21:04', service: '霓虹東京 NEON TOKYO', status: 'processing',
    payMethod: '銀行轉帳', total: 700,
    cards: [
      { name: '4509-1234-5678', account: 'player@michidart.tw', goal: '主題綁定', amount: 350 },
      { name: '4509-8821-0042', account: 'ken.dart@gmail.com',  goal: '主題綁定', amount: 350 },
    ],
  },
  {
    id: 'BR-3061', createdAt: '2026/05/12 14:33', service: '極光主題 AURORA', status: 'coded',
    payMethod: 'LINE Pay', total: 280, code: 'AUR-7K2M-9QX4',
    cards: [
      { name: '4509-1234-5678', account: 'player@michidart.tw', goal: '主題綁定', amount: 280 },
    ],
  },
  {
    id: 'BR-3024', createdAt: '2026/04/18 19:50', service: 'Fun Dart · 大富翁模式', status: 'done',
    payMethod: '現金面交', total: 420,
    cards: [
      { name: '4509-1234-5678', account: 'player@michidart.tw', goal: '遊戲解鎖', amount: 420 },
    ],
  },
];

/**
 * 常用卡片 mock（可重複帶入登記）。後端 API: GET/POST/PUT/DELETE /api/me/saved-cards
 * 為保護帳號安全，不存密碼。
 */
export const SAVED_CARDS = [
  { id: 'sc1', label: '我自己', cardNo: '4509-1234-5678', account: 'player@michidart.tw', machine: 'D3', note: '主帳號' },
  { id: 'sc2', label: '阿賢',   cardNo: '4509-8821-0042', account: 'ken.dart@gmail.com',  machine: 'D3', note: '常一起約鏢' },
  { id: 'sc3', label: '小美',   cardNo: '4218-5567-9931', account: 'mei0418@gmail.com',   machine: 'D2', note: '' },
];
